import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-verrVerlies',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-verrVerlies.component.html',
  styleUrl: './tekst-verrVerlies.component.scss',
})
export class TekstVerrVerliesComponent implements OnInit {

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();

  public korting = 0;

  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
      if (this.year == 2024 || this.year == 2025 || this.year == 2026) {
        this.korting = 24.50
      }
    })
  }

}
